import {
    Component, ViewEncapsulation

} from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { fuseAnimations } from '../../../../../core/animations';

/** Local file */
import { spekwo, spekwoType } from '../../utils/index';

/**Service file */
import { EcommerceOrderService } from '../order/order.service';
import { SolutionFormService } from './solutionForm.service';
import { CommonOrdersService } from '../orders/commonOrders.service';

@Component({
    selector: 'solution-form',
    templateUrl: './solutionForm.component.html',
    styleUrls: ['./solutionForm.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})

export class SolutionFormComponent {

    orderType: string;
    currentOrderId: number;

    propertyTypes = spekwo;
    spekwoType = spekwoType;

    selectedOrder: any = {};

    orderDetailSpinner: boolean = false; /**Spinner */
    orderFetchSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        /**Service file */
        private orderService: EcommerceOrderService,
        public solutionFormService: SolutionFormService,
        public commonOrdersService: CommonOrdersService,
    ) {

        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = params.id;

        });

    }

    ngOnInit() {

        this.getOrder();
        this.getOrderById();
        // this.ocrDocFetch(this.currentOrderId);

    }

    ngOnDestroy() {
        this.orderFetchSubscription && this.orderFetchSubscription.unsubscribe();
    }

    getOrder() {
        // this.orderDetailSpinner = true;

        this.orderService.getOrder(this.currentOrderId)
            .then(() => {

                // 1.Subscribe to update order on changes -get current order details
                // this.orderFetchSubscription = this.orderService.onOrderChanged
                //     .subscribe(order => {

                //         this.selectedOrder = order;

                //         _.each(this.selectedOrder.line_items, item => {
                //             this.orderType = this.propertyTypes[item.sku];
                //         })
                //         this.orderDetailSpinner = false;

                //     }, () => {
                //         this.orderDetailSpinner = false;
                //     });

            })
            .catch(() => {
                this.orderDetailSpinner = false;
            })
    }

    async getOrderById() {
        this.orderDetailSpinner = true;
        await this.commonOrdersService.getOrderByOrderId(this.currentOrderId).then((orderRes: any) => {
            let orderDetails = orderRes && orderRes.data && orderRes.data.allOrders && orderRes.data.allOrders.nodes &&
                orderRes.data.allOrders.nodes.length > 0 && orderRes.data.allOrders.nodes[0] && orderRes.data.allOrders.nodes[0].orderContent ? orderRes.data.allOrders.nodes[0].orderContent : [];
            let orderDetailsJson = JSON.parse(orderDetails);
            let line_items = orderDetailsJson && orderDetailsJson.line_items && orderDetailsJson.line_items.length > 0 ? orderDetailsJson.line_items : [];
            this.orderType = line_items.length > 0 && line_items[0].sku ? line_items[0].sku : null;
            this.orderDetailSpinner = false;

        }).catch((orderErr) => {
            console.log("orderErr", orderErr);
            this.orderDetailSpinner = false;
        });
    }

    /**Get ocr document */
    ocrDocFetch(currentOrderId) {
        // this.solutionFormService.GetOcrDocument(currentOrderId);
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/solutionForm.component.ts